module.exports = __webpack_public_path__ + "img/hospitality-home.c7d44ee2.jpg";